import LoadingButton from '@mui/lab/LoadingButton';
import React from 'react';

export const SWLoadingButton = (props?: any): JSX.Element => (
  <LoadingButton variant="contained" color="primary" {...props}>
    {props.children}
  </LoadingButton>
);
